<template>
  <div>
    <!-- 画像アップロード -->
    <el-form label-position="top">
      <el-form-item label="画像アップロード">
        <el-upload
          class="upload-demo"
          action="#"
          :http-request="handleFileChange"
          :show-file-list="false"
          :before-upload="beforeUpload"
          list-type="picture-card"
        >
          <img v-if="imageUrl" :src="imageUrl" class="uploaded-image" />
          <el-icon v-else class="upload-icon"><Plus /></el-icon>
        </el-upload>
      </el-form-item>
    </el-form>

    <el-divider />

    <!-- 日本語 & 英語 タイトルと内容 -->
    <el-row :gutter="20">
      <el-col :span="12">
        <h3>日本語</h3>
        <el-form label-position="top">
          <el-form-item label="タイトル">
            <el-input v-model="form.hero_title_ja" type="textarea" :rows="2" required />
          </el-form-item>
          <el-form-item label="内容">
            <el-input v-model="form.hero_content_ja" type="textarea" :rows="5" required />
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <h3>英語</h3>
        <el-form label-position="top">
          <el-form-item label="Title">
            <el-input v-model="form.hero_title_en" type="textarea" :rows="2" required />
          </el-form-item>
          <el-form-item label="Content">
            <el-input v-model="form.hero_content_en" type="textarea" :rows="5" required />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <el-divider />

    <!-- 保存ボタン -->
    <el-button type="primary" @click="confirmSave">保存</el-button>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { Plus } from "@element-plus/icons-vue";
import { supabase } from "@/supabase.js"; // Supabase 连接

export default {
  setup() {
    const form = ref({
      hero_title_ja: "",
      hero_title_en: "",
      hero_content_ja: "",
      hero_content_en: "",
      hero_img: "",
    });
    const imageUrl = ref("");
    let selectedFile = null;

    // 📌 Supabase: 获取 `home_info` 数据
    const fetchData = async () => {
      const { data, error } = await supabase
        .from("home_info")
        .select("hero_title_ja, hero_content_ja, hero_title_en, hero_content_en, hero_img")
        .eq("id", "home_info")
        .single();

      if (error) {
        console.error("データ取得エラー:", error);
        ElMessage.error("データ取得エラー");
      } else {
        form.value = data;
        imageUrl.value = data.hero_img;
      }
    };

    // 📌 处理图片上传（本地预览）
    const handleFileChange = (file) => {
      selectedFile = file.file;
      const reader = new FileReader();
      reader.onload = (e) => {
        imageUrl.value = e.target.result;
      };
      reader.readAsDataURL(selectedFile);
    };

    // 📌 仅允许 JPG/PNG 图片
    const beforeUpload = (file) => {
      const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        ElMessage.error("JPG/PNG 形式のみ対応しています。");
        return false;
      }
      return true;
    };

    // 📌 上传图片到 Supabase Storage 并返回 URL
    const uploadImage = async () => {
      console.log("selectedFile:"+selectedFile);
      
      if (!selectedFile) return form.value.hero_img; // 如果未选择新图片，保留原 URL

      // const filePath = `home_info/${selectedFile.name}`;
      const fileExt = selectedFile.name.split(".").pop(); // 获取文件扩展名
      const fileName = `${selectedFile.uid}.${fileExt}`; // 生成唯一文件名
      const filePath = `home_info/${fileName}`;

      // 先删除旧文件（如果有）
      if (form.value.hero_img) {
        const oldFileName = form.value.hero_img.split("/").pop();
        await supabase.storage.from("img").remove([`home_info/${oldFileName}`]);
      }

      // 上传新文件
      const { error } = await supabase.storage.from("img").upload(filePath, selectedFile);

      if (error) {
        console.error("画像アップロード失敗:", error);
        ElMessage.error("画像アップロード失敗しました。");
        return form.value.hero_img;
      }

      // 获取上传后的 URL
      return supabase.storage.from("img").getPublicUrl(filePath).data.publicUrl;
    };

    // 📌 保存数据
    const saveData = async () => {
      if (!form.value.hero_title_ja 
      || !form.value.hero_title_en 
      || !form.value.hero_content_ja 
      || !form.value.hero_content_en
      || !imageUrl.value
    
    ) {
        ElMessage.error("全ての項目を入力してください。");
        return;
      }

      // 先上传图片，获取 URL
      form.value.hero_img = await uploadImage();

      // 更新 `home_info` 表
      const { error } = await supabase
        .from("home_info")
        .update({
          hero_title_ja: form.value.hero_title_ja,
          hero_title_en: form.value.hero_title_en,
          hero_content_ja: form.value.hero_content_ja,
          hero_content_en: form.value.hero_content_en,
          hero_img: form.value.hero_img,
        })
        .eq("id", "home_info");

      if (error) {
        console.error("データ保存エラー:", error);
        ElMessage.error("保存に失敗しました。");
      } else {
        ElMessage.success("データを保存しました。");
      }
    };

    // 📌 确认保存对话框
    const confirmSave = () => {
      ElMessageBox.confirm("この内容で保存しますか？", "確認", {
        confirmButtonText: "保存",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
        .then(() => {
          saveData();
        })
        .catch(() => {
          ElMessage.info("保存をキャンセルしました。");
        });
    };

    onMounted(fetchData);

    return {
      form,
      imageUrl,
      handleFileChange,
      confirmSave,
      beforeUpload,
      Plus,
    };
  },
};
</script>
<style lang="stylus" scoped>
.uploaded-image {
  height: 150px; /* 只控制高度 */
  width: auto; /* 宽度自适应 */
  object-fit: contain; /* 保持原比例，不裁剪 */
  border-radius: 8px; /* 圆角 */
  display: block;
  max-width: 100%; /* 防止超出父容器 */
}
:deep(.el-upload--picture-card) {
    --el-upload-picture-card-size: 148px;
    align-items: center;
    background-color: var(--el-fill-color-lighter);
    border: 1px dashed var(--el-border-color-darker);
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-flex;
    height: var(--el-upload-picture-card-size);
    justify-content: center;
    vertical-align: top;
    width: 300px;
}
</style>